import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import './index.css'
import { setOnUnauthorized } from '@/api/adminApi'
import { useAdminAuth } from '@/store/authStore'
import { initErrorReporter } from '@/lib/errorReporter'

// Fire-and-forget: registers window.__errorReporter (used by ErrorBoundary)
// if VITE_SENTRY_DSN or VITE_ERROR_INGEST_URL is set. Safe no-op otherwise.
initErrorReporter()

setOnUnauthorized(() => {
  useAdminAuth.getState().logout()
  if (!window.location.pathname.startsWith('/admin/login')) {
    window.location.assign('/admin/login')
  }
})

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        const status = (error as { response?: { status?: number } })?.response?.status
        if (status === 401 || status === 403 || status === 404) return false
        return failureCount < 2
      },
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
)
